import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  clearAllGISServices,
  toggleGISService,
} from '@rsos/reduxDataStore/src/features/gisServices/gisServicesSlice';
import checkEsriMapAccess from '@rsos/utils/checkEsriMapAccess';
import checkGISServicesAccess from '@rsos/utils/checkGISServicesAccess';
import usePortalType from '@rsos/utils/usePortalType';

const useGISHelpers = () => {
  const { isPremiumUser } = usePortalType();

  const hasEsriMapAccess =
    useSelector(state =>
      checkEsriMapAccess({
        psaps: state.psaps,
        sinatra: state.sinatra,
      }),
    ) && isPremiumUser;

  const hasGISServicesAccess = useSelector(state =>
    checkGISServicesAccess({
      psaps: state.psaps,
      sinatra: state.sinatra,
    }),
  );

  const gisSupplementalServices = useSelector(
    state => state.gisServices.supplementalServices,
  );

  const gisWMSServices = useSelector(state => state.gisServices.wmsServices);

  const gisWMTSServices = useSelector(state => state.gisServices.wmtsServices);

  const gisMapLayersControlServices = useMemo(() => {
    return [...gisSupplementalServices, ...gisWMSServices, ...gisWMTSServices];
  }, [gisSupplementalServices, gisWMSServices, gisWMTSServices]);

  const hasGISMapLayersControlServices = useMemo(() => {
    return !!(
      hasEsriMapAccess &&
      hasGISServicesAccess &&
      gisMapLayersControlServices?.length
    );
  }, [hasEsriMapAccess, hasGISServicesAccess, gisMapLayersControlServices]);

  const activeGISServices = useSelector(
    state => state.gisServices.activeGISServices,
  );

  const numActiveGISServices = activeGISServices.length;

  return {
    activeGISServices,
    clearAllGISServices,
    gisMapLayersControlServices,
    hasEsriMapAccess,
    hasGISMapLayersControlServices,
    numActiveGISServices,
    toggleGISService,
  };
};

export default useGISHelpers;
